import React from "react"
import {FieldTableCellProps, getTableCellStyle} from "../../../../render/table/table-cell"

// const debug = "FieldProjectTotalOpenAll_TableCell"
const debug = false


export default function FieldProjectTotalOpenAll_TableCell(props:FieldTableCellProps) {

    return (
        <div className="cell-flex" style={getTableCellStyle(props)}>
            {!!props.listItem.tree.numChildren.projectTasksTotal &&
                <div className="ui5-txt-less-important-small">
                    {props.listItem.tree.numChildren.projectTasksOpen} / {props.listItem.tree.numChildren.projectTasksTotal}
                </div>
            }
        </div>
    )

}

